/*
 * © 2024 Snyk Limited
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidPolicyApplyError = void 0;
const types_1 = require("../types");
const problem_error_1 = require("../problem-error");
/**
 * @class
 * @name InvalidPolicyApplyError
 * @description Snyk could not apply a policy whilst executing a test because the configuration for the policy was invalid.
 * You may be able to fix the policy and try again.
 *
 * See more:
 * - [https://docs.snyk.io/manage-risk/policies](https://docs.snyk.io/manage-risk/policies)
 * @summary Unable to apply a policy with an invalid configuration
 * @category Policies
 * @param {string} details                         the specific details that causes this error
 * @param {Classification} classification          the error classification determining if the error is user-actionable or not
 * @param {Record<string, any>} [additionalData]   a collection of relevant data specific to this error
 * @param {Error} [cause]                          the `Error` type that caused this error to be thrown
 * @param {string} [instance]                      the instance to use for this error. Overrides 'instance' metadata
 */
class InvalidPolicyApplyError extends problem_error_1.ProblemError {
    constructor(details, additionalData, cause, instance, logs) {
        super({
            title: 'Unable to apply a policy with an invalid configuration',
            type: 'https://docs.snyk.io/scan-with-snyk/error-catalog#snyk-policy-0001',
            status: 422,
            errorCode: 'SNYK-POLICY-0001',
            level: 'error',
            classification: types_1.Classification.ACTIONABLE,
            instance,
        }, details, Object.assign({ links: [
                'https://docs.snyk.io/manage-risk/policies',
            ] }, additionalData), cause, logs);
        this.name = this.constructor.name;
    }
}
exports.InvalidPolicyApplyError = InvalidPolicyApplyError;
//# sourceMappingURL=Policies-error-catalog.js.map